import { LitElement, html } from "lit-element";
import WebMidi from "webmidi";

import { scale, getRandomInRange, getRandomRGBColor } from "./utils";

class RhythmicImage extends LitElement {
    static get properties() {
        return {
            source: { type: String },
            width: { type: String },
            height: { type: String },
            widthDivision: { type: Number },
            heightDivision: { type: Number },
            left: { type: String },
            top: { type: String },
            bottom: { type: String },
            right: { type: String },
            offset: { type: Number },
            position: { type: String },
            opacity: { type: Number },
            lowNote: { type: Number },
            highNote: { type: Number },
            mixBlendMode: { type: String },
            ccResponsive: { type: Boolean },
            knobOneNumber: { type: Number },
            knobTwoNumber: { type: Number },
            knobThreeNumber: { type: Number },
            knobFourNumber: { type: Number },
            knobOneValue: { type: Number },
            knobTwoValue: { type: Number },
            knobThreeValue: { type: Number },
            knobFourValue: { type: Number },
            debug: { type: Boolean },
            url: { type: String },
            orientation: { type: String },
            numNotes: { type: Number },
        };
    }

    constructor() {
        super();

        this.source = "IAC Driver Bus 1";
        this.container = null;
        this.width = null;
        this.height = null;
        this.widthDivision = 1;
        this.heightDivision = 1;
        this.left = "0%";
        this.top = "0%";
        this.bottom = null;
        this.fill = false;
        this.lowNote = 21;
        this.highNote = 108;
        this.mixBlendMode = "normal";
        this.position = "relative";
        this.knobOneNumber = null;
        this.knobTwoNumber = null;
        this.knobThreeNumber = null;
        this.knobFourNumber = null;
        this.knobOneValue = 0;
        this.knobTwoValue = 0;
        this.knobThreeValue = 0;
        this.knobFourValue = 0;
        this.ccResponsive = false;
        this.backgroundColor = "rgb(0, 0, 0";
        this.debug = false;
        this.url = "";
        this.activeNotes = [];
        this.orientation = "vertical";
        this.offset = 0;
        this.noteCount = 0;
        this.numNotes = 4;
        this.opacity = 1;

        WebMidi.enable((error) => {
            if (error) {
                console.log(error);
            } else {
                const arturia = WebMidi.getInputByName("Arturia MINILAB");
                const midiSource = WebMidi.getInputByName(this.source);
                midiSource.addListener(
                    "noteon",
                    "all",
                    this.handleNoteOn.bind(this)
                );
                midiSource.addListener(
                    "noteoff",
                    "all",
                    this.handleNoteOff.bind(this)
                );

                midiSource.addListener(
                    "controlchange",
                    "all",
                    this.handleControlChange.bind(this)
                );
            }
        });
    }

    handleControlChange(e) {}

    handleNoteOn(e) {
        if (e.note.number >= this.lowNote && e.note.number <= this.highNote) {
            this.container = this.shadowRoot.querySelector("#container");
            const element = document.createElement("div");
            element.id = `note${e.note.number}`;
            const { note } = e;
            // const scaledVelocity = scale(e.velocity, 0, 1, 0, 127);
            note.velocity = e.velocity;
            // this.note = note;
            element.style = this.getNoteStyle(note);

            this.activeNotes.push(element);
            this.container.appendChild(element);

            if (this.noteCount >= this.numNotes - 1) {
                console.log(this);
                this.noteCount = 0;
            } else {
                this.noteCount += 1;
                console.log(`note: ${this.noteCount} of ${this.numNotes}`);
            }
        }
    }

    handleNoteOff(e) {
        if (e.note.number >= this.lowNote && e.note.number <= this.highNote) {
            const element = this.shadowRoot.querySelector(
                `#note${e.note.number}`
            );

            if (element) {
                //console.log('element removed');
                for (let i = 0; i < this.activeNotes.length; i++) {
                    if (this.activeNotes[i].id === element.id) {
                        this.activeNotes.splice(i, 1);
                        break;
                    }
                }
                this.container.removeChild(element);
            } else {
                console.log("no element to remove");
            }
        }
    }
    getNoteStyle(note) {
        let style = ``;

        console.log(note.velocity);

        const containerHeight = window
            .getComputedStyle(this.container)
            .height.slice(0, -2);
        const containerWidth = window
            .getComputedStyle(this.container)
            .width.slice(0, -2);

        const size = `cover`;

        if (this.orientation === "vertical") {
            style = `
      position: absolute;
      top: ${(containerHeight / this.numNotes) * this.noteCount}px;
      width: ${containerWidth}px;
      height: ${containerHeight / this.numNotes}px;
      background: url(${this.url});
      background-size: ${size};
      background-repeat: no-repeat;
      background-position: center;
      opacity: ${note.velocity}     
    `;
        }

        if (this.orientation === "horizontal") {
            style = `
      display: inline-block;
      position: absolute;
      left: ${(containerWidth / this.numNotes) * this.noteCount}px;
      width: ${containerWidth / this.numNotes};
      height: ${containerHeight};
      background: url(${this.url});
      background-size: ${size};
      background-repeat: no-repeat;
      background-position: center;
      outline-style: ${this.debug ? "dashed" : "none"};
      opacity: ${note.velocity}
      `;
        }

        return style;
    }

    render() {
        if (WebMidi.supported) {
            return html`
                <style>
                    :host {
                      margin: 0 auto;
                    }
                    #container {
                      position: ${this.position};
                      display: inline-block;
                      width: ${this.width
                        ? this.width
                        : `calc(100% / ${this.widthDivision})`};

                      height: ${this.height
                        ? this.height
                        : `calc(100% / ${this.heightDivision})`};

                      left: ${this.left};
                      top: ${this.top};
                      background: transparent;
                      opacity: ${this.opacity};
                </style>
                <div id="container"></div>
            `;
        } else {
            return html``;
        }
    }
}

customElements.define("rhythmic-image", RhythmicImage);
